import React from "react";
import { motion } from "framer-motion";
import { fadeUp, stagger, viewport } from "@/lib/motion";
import { FEATURES } from "@/data/smartContainer";
import SectionHeader from "./SectionHeader";

export default function FeaturesSection() {
  return (
    <section id="why" className="py-24 sm:py-32" data-testid="features-section">
      <div className="dm-container">
        <SectionHeader
          eyebrow="Why SmartContainer™"
          title="Factory-direct purchasing, coordinated as one operation."
          description="Everything that makes multi-manufacturer sourcing hard, re-engineered into a single procurement model."
        />
        <motion.div variants={stagger} initial="hidden" whileInView="visible" viewport={viewport}
          className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {FEATURES.map((f) => (
            <motion.div key={f.title} variants={fadeUp} className="dm-card dm-card-hover p-7 group"
              data-testid={`feature-card-${f.title.toLowerCase().replace(/\s+/g, "-")}`}>
              <span className="grid place-items-center h-11 w-11 rounded-xl bg-slate-50 border border-slate-200 group-hover:bg-blue-50 group-hover:border-blue-100 transition-colors duration-300">
                <f.icon className="h-5 w-5 text-slate-700 group-hover:text-blue-600 transition-colors duration-300" strokeWidth={1.75} />
              </span>
              <h3 className="mt-5 text-lg font-bold text-slate-900">{f.title}</h3>
              <p className="mt-2.5 text-sm text-slate-500 leading-relaxed">{f.text}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
